import { useEffect, useState } from 'react';

const DISMISSED_KEY = 'aicf.desktop-alerts.dismissed';

export function DesktopAlertsPrompt(): JSX.Element | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'default') return;
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(DISMISSED_KEY) === '1';
    } catch {
    }
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const close = (remember: boolean): void => {
    setVisible(false);
    if (!remember) return;
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
    }
  };

  return (
    <div
      role="dialog"
      aria-label="Desktop alerts"
      data-testid="desktop-alerts-prompt"
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 900,
        width: 330,
        padding: '14px 16px',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        boxShadow: '0 8px 28px rgba(0,0,0,0.16)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <span aria-hidden="true">🔔</span>
        <span style={{ fontWeight: 600, fontSize: 13 }}>Turn on desktop alerts?</span>
      </div>
      <p style={{ fontSize: 12, color: 'var(--text-muted)', margin: '0 0 12px', lineHeight: 1.5 }}>
        Get notified about approvals awaiting you and SLA breaches, even when this tab is in
        the background.
      </p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button type="button" className="btn ghost sm" onClick={() => close(true)}>
          Not now
        </button>
        <button
          type="button"
          className="btn primary sm"
          onClick={() => {
            void Notification.requestPermission().finally(() => close(true));
          }}
        >
          Enable
        </button>
      </div>
    </div>
  );
}
